import { useState } from "react";
import {GridFooterContainer} from '@mui/x-data-grid';
import { Spinner } from "react-bootstrap";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Fab from "@mui/material/Fab";
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';

import SendIcon from '@mui/icons-material/Send';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

import APICom from "../APICom.js";
import { current } from "@reduxjs/toolkit";



function GridFooter({
    rows,
    drivers,
    vehiclesWithID,
    setRows,
    messageTemplate,
    rowSelectionModel,
    globalInLoadAPIURL,
    finalAffiliate,
    replaceSmsVars
}) {

    const [open, setOpen] = useState(false);
    const [newRowsCount, setNewRowsCount] = useState(0);

    const selectedIds = Array.from(rowSelectionModel.ids)

    const hasAnySelection = selectedIds.length > 0
  
    const allRowsHaveVehicle = selectedIds.every(id => {
      const row = rows.find(r => r.id === id)
      return ((row?.phone && row.phone !== '--------') && (row?.routeTime && row.routeTime.length > 0) && (row?.driver && row.driver.length > 0));
    })

    const canSend = hasAnySelection && allRowsHaveVehicle

    const [sentMessage, setSentMessage] = useState(false);

    return(
        <GridFooterContainer
            sx={{
                display: 'flex',justifyContent: 'space-between',
                px: 2, mx: 'auto',
                width: '100%', maxWidth: '97vw',
                boxSizing: 'border-box'
            }}
        >

            <Box sx={{ display: 'flex', alignItems: 'center'}}>
                <Fab
                    sx={{color: 'var(--headerfooter-bg-color)', backgroundColor: 'var(--headerfooter-bg-color)',
                        '&:hover': {backgroundColor: 'var(--main-hover-color)'},
                    }}
                    size='small'
                    onClick={() => handleAddRow()}
                 >
                    <AddIcon sx={{color: 'white'}}/>
                </Fab>
            </Box>

            {open ? 
            (<Collapse in={open} sx={{ height: 60, marginTop: 1, marginBottom: -0.5}}> 
                <Alert 
                    icon ={<CheckCircleOutlineIcon/>} 
                    sx={{
                        '&:hover': { border: 2 },
                        padding: '4px 8px', 
                        height: '100%', maxHeight: '50px', 
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                    }}  
                    variant="outlined" 
                    severity="success"
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                >
                    Messages sent successfully!
                </Alert>
            </Collapse>)
            :
            (sentMessage ? 
                (<Spinner
                    as="span" animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" aria-busy= {sentMessage}
                    style={{ marginBottom: '3px', top: '50%', left: '50%' }}
                />)
            :
            (canSend ? 
                (<Button sx ={{'&:hover': {border: 2},}} variant="outlined" color="success" endIcon={<SendIcon />} onClick={() => sendMessages()}>
                    Send Messages
                </Button>)
                :
                (<Button color="error" disabled variant="outlined" endIcon={<CancelScheduleSendIcon/>} 
                    sx={{
                        '&.Mui-disabled': {
                        borderColor: theme => theme.palette.error.main,
                        color: theme => theme.palette.error.main,
                        opacity: 0.6,
                        },
                }}>
                    Send Messages
                </Button>)
            ))}
        </GridFooterContainer>
    )


    async function sendMessages(){
        try{
            setSentMessage(true);

            const sendMsgsUrl = globalInLoadAPIURL + "/TripReservation/SendPushNotificationAndSMS";
            const selectedIds = Array.from(rowSelectionModel.ids)
    
            selectedIds.forEach(async id => {
    
                const row = rows.find(r => r.id === id)
                const driver = drivers.current.find(d => d.Name === row.driver)
                const vehicle = vehiclesWithID.current.find(v => v.vehicleNo === row.vehicleNo)

                const data = JSON.stringify({
                    "marsid": "N",
                    "phone": row.phone.replace(/-/g, ''),
                    "notificationtype": "1",
                    "clientid": "-1",
                    "agentname": "",
                    "agentid": "",
                    "message": row.sms.replace(/"/g, '\\"'),
                    "ireqaffiliateid": finalAffiliate.current,
                    "urlparams": ""
                })


                const sendResponse = await APICom.fetchData('full', sendMsgsUrl, 'post', { "Content-Type": "application/json" }, data, null )
                if (sendResponse.error.length === 0){
                    logMessageSent(driver.DriverID, vehicle.vehicleID, row.id, row.sms, row.phone, row.email ?? "", finalAffiliate.current);
                }
            })
        }
        catch(err){
        }
    };

    async function logMessageSent(iDriverID, iVehicleID, vVirtualRoute, smsMessage, vDriverPhone, vdriverEmail, iAffiliateID){
        console.log(iAffiliateID)

        const logMsgsUrl = globalInLoadAPIURL + "/TripReservation/SaveToDriverRouteMessaging";

        const data = JSON.stringify({
            "idriverid": iDriverID,
            "ivehicleid": iVehicleID,
            "vvirtualroute": vVirtualRoute,
            "smsmessage": smsMessage,
            "vdriverphone": vDriverPhone,
            "vdriveremail": vdriverEmail,
            "iaffiliateid": iAffiliateID
        })

        const sendResponse = await APICom.fetchData('full', logMsgsUrl, 'post', { "Content-Type": "application/json" }, data, null);
        if (sendResponse.error.length === 0){
            setSentMessage(false);
            setOpen(true);
        }
    }

    function handleAddRow(){
        const newRow = {
        id:        `blankRoute-${newRowsCount}`,
        routeTime: '--------',
        vehicleNo: '',
        driver:    '',
        phone:     '--------',
        email:     '--------',
        sms: messageTemplate,
        response:  ''
        }

        newRow.sms = replaceSmsVars(messageTemplate, newRow);

        setRows(prevRows => [...prevRows, newRow]);
        setNewRowsCount(newRowsCount + 1);
    }
};    

export default GridFooter;

export const buttonSX = {
    // color: 'black',
    color: 'var(--headerfooter-bg-color)',
    borderColor: 'var(--headerfooter-bg-color)',
    '&:hover': {
        border: '2px solid var(--headerfooter-bg-color)'
    },
    '&.Mui-focused': {
        borderColor: 'var(--headerfooter-bg-color)',
    },
    
};